/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { queryOptions, useQuery, useSuspenseQuery } from '@tanstack/react-query'
import type {
	UseQueryOptions,
	UseQueryResult,
	UseSuspenseQueryOptions,
	UseSuspenseQueryResult,
} from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { whatsAppAccountShowBusinessProfile } from '../../axios/whatsAppAccountShowBusinessProfile'
import type {
	WhatsAppAccountShowBusinessProfileError,
	WhatsAppAccountShowBusinessProfilePathParams,
	WhatsAppAccountShowBusinessProfileResponse,
} from '../../types/WhatsAppAccountShowBusinessProfile'

export const whatsAppAccountShowBusinessProfileQueryKey = (
	organisationId: WhatsAppAccountShowBusinessProfilePathParams['organisationId'],
) => [{ url: '/organisations/:organisationId/whatsapp-account/business-profile', params: { organisationId } }] as const

export type WhatsAppAccountShowBusinessProfileQueryKey = ReturnType<typeof whatsAppAccountShowBusinessProfileQueryKey>

/** @see backend/nexus/modules/Campaign/Http/Controllers/WhatsAppAccountController.php WhatsAppAccountController::showBusinessProfile */
export function whatsAppAccountShowBusinessProfileQueryOptions(
	organisationId: WhatsAppAccountShowBusinessProfilePathParams['organisationId'],
	config?: AxiosRequestConfig,
) {
	return queryOptions<
		WhatsAppAccountShowBusinessProfileResponse,
		AxiosError<WhatsAppAccountShowBusinessProfileError>,
		WhatsAppAccountShowBusinessProfileResponse,
		WhatsAppAccountShowBusinessProfileQueryKey
	>({
		queryKey: whatsAppAccountShowBusinessProfileQueryKey(organisationId),
		queryFn: ({ signal }) =>
			whatsAppAccountShowBusinessProfile(organisationId, { signal, ...config }).then(res => res.data),
		enabled: !!organisationId,
	})
}

/** @see backend/nexus/modules/Campaign/Http/Controllers/WhatsAppAccountController.php WhatsAppAccountController::showBusinessProfile */
export function useWhatsAppAccountShowBusinessProfile<TSelectData = WhatsAppAccountShowBusinessProfileResponse>(
	organisationId: WhatsAppAccountShowBusinessProfilePathParams['organisationId'],
	options?:
		& Partial<
			Omit<
				UseQueryOptions<
					WhatsAppAccountShowBusinessProfileResponse,
					AxiosError<WhatsAppAccountShowBusinessProfileError>,
					TSelectData,
					WhatsAppAccountShowBusinessProfileQueryKey
				>,
				'queryKey' | 'queryFn'
			>
		>
		& { queryKey?: readonly unknown[] },
): UseQueryResult<TSelectData, AxiosError<WhatsAppAccountShowBusinessProfileError>> {
	const { queryKey: customQueryKey, ...opts } = options ?? {}
	return useQuery({
		...whatsAppAccountShowBusinessProfileQueryOptions(organisationId),
		...opts as any,
		...(customQueryKey ? { queryKey: customQueryKey as any } : {}),
	})
}

/** @see backend/nexus/modules/Campaign/Http/Controllers/WhatsAppAccountController.php WhatsAppAccountController::showBusinessProfile */
export function useWhatsAppAccountShowBusinessProfileSuspense<TSelectData = WhatsAppAccountShowBusinessProfileResponse>(
	organisationId: WhatsAppAccountShowBusinessProfilePathParams['organisationId'],
	options?:
		& Partial<
			Omit<
				UseSuspenseQueryOptions<
					WhatsAppAccountShowBusinessProfileResponse,
					AxiosError<WhatsAppAccountShowBusinessProfileError>,
					TSelectData,
					WhatsAppAccountShowBusinessProfileQueryKey
				>,
				'queryKey' | 'queryFn'
			>
		>
		& { queryKey?: readonly unknown[] },
): UseSuspenseQueryResult<TSelectData, AxiosError<WhatsAppAccountShowBusinessProfileError>> {
	const { queryKey: customQueryKey, ...opts } = options ?? {}
	return useSuspenseQuery({
		...whatsAppAccountShowBusinessProfileQueryOptions(organisationId),
		...opts as any,
		...(customQueryKey ? { queryKey: customQueryKey as any } : {}),
	})
}
